import { FunctionComponent, MouseEvent, useRef } from "react";
import { AuthorisedDeviceRevokingState } from "@pjs/user-domain";
import { Button, ButtonClass, LoadingSpinner, Table } from "@pjs/core-ui";
import { useBeforeFirstPaint } from "@pjs/react-utilities";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { IAuthorisedDevicesRowProps } from "./interfaces/IAuthorisedDevicesRowProps";
import "./styles/authorised-devices-row.css";

export const AuthorisedDeviceRow: FunctionComponent<IAuthorisedDevicesRowProps> = (props) => {
    const revokeClicked = useRef(false);
    const contentRef = useRef<HTMLTableRowElement>(null);
    const isRevoking = props.device.state.descriptor === AuthorisedDeviceRevokingState.InProgress;
    const buttonLabel = !isRevoking
        ? userUiI18n.getString("external_services.authorised_devices.revoke_button_a11y", { device: props.device.deviceName })
        : userUiI18n.getString("external_services.authorised_devices.currently_revoking_a11y", { device: props.device.deviceName });

    const onRevoke = (event: MouseEvent<HTMLButtonElement>): void => {
        if (!revokeClicked.current && !isRevoking) {
            revokeClicked.current = true;

            props.revokeAccess(event.currentTarget, () => {
                revokeClicked.current = false;
            });
        }
    };

    useBeforeFirstPaint(() => {
        return () => {
            if (contentRef.current !== null && contentRef.current.contains(document.activeElement)) {
                props.onUnmountWithFocus(document.activeElement as HTMLElement);
            }
        };
    });

    return (
        <Table.Row>
            <Table.Cell>{props.device.clientName}</Table.Cell>
            <Table.Cell>{props.device.deviceName}</Table.Cell>
            <Table.Cell>
                <div className="uui-authorised-devices__revoke-cell" ref={contentRef}>
                    <Button
                        className={`${ButtonClass.Outlined} uui-authorised-devices__revoke-button`}
                        ariaLabel={buttonLabel}
                        ariaDisabled={isRevoking}
                        onClick={onRevoke}>
                        {isRevoking && <LoadingSpinner className="uui-authorised-devices__revoking-spinner" />}
                        {!isRevoking && userUiI18n.getString("external_services.authorised_devices.revoke")}
                    </Button>
                </div>
            </Table.Cell>
        </Table.Row>
    );
};
